import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { RequestId, RequestIdService } from '../auth/services/request-id.service';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SmsTimerService {

  private interval = null;
  private timerSubject: BehaviorSubject<number>;
  public timer: Observable<number>;
  public timeout = 30;

  constructor() {
    this.timerSubject = new BehaviorSubject<number>(0);
    this.timer = this.timerSubject.asObservable();

    this.timeout = environment.smsTimeout || this.timeout;
  }

  onSmsTimer(time) {
    const allowedTime = time + (this.timeout * 1000);

    if (this.interval) {
      clearInterval(this.interval);
    }

    if (Date.now() < allowedTime) {
      this.timerSubject.next(Math.floor((allowedTime - Date.now()) / 1000));

      this.interval = setInterval(() => {
        if (this.timerSubject.value <= 0) {
          clearInterval(this.interval);
          return this.offSmsTimer();
        }

        this.timerSubject.next(this.timerSubject.value - 1);
      }, 1000);
    }
  }

  offSmsTimer() {
    this.timerSubject.next(0);
  }
}
